import { useState } from 'react';
import { IconCheck, IconCopy } from './icons';

interface CopyButtonProps {
  text: string;
  size?: number;
  /** Shown beside the icon, making it a labeled button rather than a bare
   * icon; the label also names what the button copies. */
  label?: string;
  className?: string;
}

export function CopyButton({ text, size = 13, label, className }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // fallback: ignore silently
    }
  };

  if (label) {
    return (
      <button type="button" onClick={handleCopy} className={className} title={copied ? 'Copied!' : label}>
        {copied ? <IconCheck size={size} /> : <IconCopy size={size} />}
        {copied ? 'Copied' : label}
      </button>
    );
  }

  return (
    <button
      onClick={handleCopy}
      title={copied ? 'Copied!' : 'Copy'}
      style={{
        background: 'none',
        border: 'none',
        padding: '1px 3px',
        cursor: 'pointer',
        color: copied ? 'var(--accent)' : 'var(--muted)',
        opacity: copied ? 1 : 0.45,
        transition: 'opacity 0.15s, color 0.15s',
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        lineHeight: 1,
      }}
      onMouseEnter={(e) => { if (!copied) (e.currentTarget as HTMLButtonElement).style.opacity = '1'; }}
      onMouseLeave={(e) => { if (!copied) (e.currentTarget as HTMLButtonElement).style.opacity = '0.45'; }}
    >
      {copied ? <IconCheck size={size} /> : <IconCopy size={size} />}
    </button>
  );
}
